import React from 'react';
import '../styles/ExploreProperties.css';
import heroImg from '../assets/images/ExploreProperties.jpg';
// import PropertyMapSection from '../components/PropertyMapSection';
import InvestmentGuideSection from '../components/InvestmentGuideSection';
import ScrollDownArrow from '../components/ScrollDownArrow';

import featured_villas from '../assets/images/properties/Explore Properties Villas.jpg';
import featured_townhouses from '../assets/images/properties/Explore Properties Townhouses.jpg';
import featured_apartments from '../assets/images/properties/Explore Properties Apartment.jpg';
import featured_penthouses from '../assets/images/properties/Explore Properties Penthouse.jpg';
import featured_duplexes from '../assets/images/properties/Explore Properties Duplexes.jpg';

const properties = [
  {
    title: 'Villas',
    image: featured_villas
  },
  {
    title: 'Townhouses',
    image: featured_townhouses
  },
  {
    title: 'Apartments',
    image: featured_apartments
  },
  {
    title: 'Penthouses',
    image: featured_penthouses
  },
  {
    title: 'Duplexes',
    image: featured_duplexes
  },
];

export default function ExploreProperties() {
  return (
    <div className="explore-properties-page">
      {/* Hero Section */}
      <section className="explore-hero" style={{ backgroundImage: `url(${heroImg})` }}>
        <div className="explore-hero-overlay"></div>
        <div className="explore-hero-content">
          <h1 className="explore-hero-title">Explore Properties</h1>
          <p className="explore-hero-subtitle">High-Grade Properties In Premium Locations</p>
        </div>
        <ScrollDownArrow targetSelector=".properties-content" />
      </section>

      {/* Intro & Property Grid */}
      <div className="properties-content">
        <div className="intro">
          <h2>High-Grade Properties In Premium Locations</h2>
          <p>
            Discover a curated selection of exclusive properties we source for you at ABBASS Global Properties. From luxurious villas and modern apartments to penthouses, we offer a range of real estate options tailored to fit your lifestyle and investment needs.
          </p>
        </div>
        <div className="property-grid three-row-two-col-layout">
          <div className="property-card grid-pos-1-1" key={properties[0].title}>
            <img src={properties[0].image} alt={properties[0].title} />
            <div className="card-overlay">
              <h3>{properties[0].title}</h3>
            </div>
          </div>
          <div className="property-card grid-pos-2-1" key={properties[1].title}>
            <img src={properties[1].image} alt={properties[1].title} />
            <div className="card-overlay">
              <h3>{properties[1].title}</h3>
            </div>
          </div>
          <div className="property-card grid-pos-1-2" key={properties[2].title}>
            <img src={properties[2].image} alt={properties[2].title} />
            <div className="card-overlay">
              <h3>{properties[2].title}</h3>
            </div>
          </div>
          <div className="property-card grid-pos-2-2" key={properties[3].title}>
            <img src={properties[3].image} alt={properties[3].title} />
            <div className="card-overlay">
              <h3>{properties[3].title}</h3>
            </div>
          </div>
          <div className="property-card grid-pos-3-2" key={properties[4].title}>
            <img src={properties[4].image} alt={properties[4].title} />
            <div className="card-overlay">
              <h3>{properties[4].title}</h3>
            </div>
          </div>
        </div>
      </div>
      {/* <PropertyMapSection /> */}
      <InvestmentGuideSection />
    </div>
  );
} 